import styled from "../../styled-components";

export const SmallDivider = styled.hr`
  background: ${({ theme }) => theme.colors.blue};
  border: 0;
  height: 4px;
  margin: 20px 0;
  width: 50px;
`;



// WEBPACK FOOTER //
// ./src/components/SmallDivider/SmallDivider.ts